"use strict";
// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/dashboard/v1/legacy_portal_service.proto (package spwn.dashboard.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyPortalDashboardService = void 0;
const legacy_portal_service_pb_1 = require("./legacy_portal_service_pb");
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from service spwn.dashboard.v1.LegacyPortalDashboardService
 */
exports.LegacyPortalDashboardService = {
    typeName: "spwn.dashboard.v1.LegacyPortalDashboardService",
    methods: {
        /**
         * ダッシュボード一覧画面用の権限のあるイベント一覧を取得する
         *
         * @generated from rpc spwn.dashboard.v1.LegacyPortalDashboardService.GetEventRoles
         */
        getEventRoles: {
            name: "GetEventRoles",
            I: legacy_portal_service_pb_1.LegacyPortalDashboardServiceGetEventRolesRequest,
            O: legacy_portal_service_pb_1.LegacyPortalDashboardServiceGetEventRolesResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * チケットもぎりダッシュボード画面から呼び出されるAPI
         * チケットidを元にチケットの詳細情報を取得する
         *
         * @generated from rpc spwn.dashboard.v1.LegacyPortalDashboardService.GetAllIssuedTicketSummary
         */
        getAllIssuedTicketSummary: {
            name: "GetAllIssuedTicketSummary",
            I: legacy_portal_service_pb_1.LegacyPortalDashboardServiceGetAllIssuedTicketSummaryRequest,
            O: legacy_portal_service_pb_1.LegacyPortalDashboardServiceGetAllIssuedTicketSummaryResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * 購入情報確認ダッシュボード画面から呼び出されるAPI
         * イベントの販売詳細情報を取得する
         *
         * @generated from rpc spwn.dashboard.v1.LegacyPortalDashboardService.GetEventSalesDetails
         */
        getEventSalesDetails: {
            name: "GetEventSalesDetails",
            I: legacy_portal_service_pb_1.LegacyPortalDashboardServiceGetEventSalesDetailsRequest,
            O: legacy_portal_service_pb_1.LegacyPortalDashboardServiceGetEventSalesDetailsResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * 注文日別のチケット販売枚数を取得する
         *
         * @generated from rpc spwn.dashboard.v1.LegacyPortalDashboardService.GetTicketSalesByOrderDate
         */
        getTicketSalesByOrderDate: {
            name: "GetTicketSalesByOrderDate",
            I: legacy_portal_service_pb_1.LegacyPortalDashboardServiceGetTicketSalesByOrderDateRequest,
            O: legacy_portal_service_pb_1.LegacyPortalDashboardServiceGetTicketSalesByOrderDateResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * ユーザー属性別のチケット販売数を取得する
         *
         * @generated from rpc spwn.dashboard.v1.LegacyPortalDashboardService.GetUserAttributeCounts
         */
        getUserAttributeCounts: {
            name: "GetUserAttributeCounts",
            I: legacy_portal_service_pb_1.LegacyPortalDashboardServiceGetUserAttributeCountsRequest,
            O: legacy_portal_service_pb_1.LegacyPortalDashboardServiceGetUserAttributeCountsResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * チケット購入者の質問結果を取得する
         *
         * @generated from rpc spwn.dashboard.v1.LegacyPortalDashboardService.GetTicketQuestionnaireResults
         */
        getTicketQuestionnaireResults: {
            name: "GetTicketQuestionnaireResults",
            I: legacy_portal_service_pb_1.LegacyPortalDashboardServiceGetTicketQuestionnaireResultsRequest,
            O: legacy_portal_service_pb_1.LegacyPortalDashboardServiceGetTicketQuestionnaireResultsResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * 自由記述の設問回答をページネーションで追加取得する
         *
         * @generated from rpc spwn.dashboard.v1.LegacyPortalDashboardService.GetTicketQuestionnaireTextAnswers
         */
        getTicketQuestionnaireTextAnswers: {
            name: "GetTicketQuestionnaireTextAnswers",
            I: legacy_portal_service_pb_1.LegacyPortalDashboardServiceGetTicketQuestionnaireTextAnswersRequest,
            O: legacy_portal_service_pb_1.LegacyPortalDashboardServiceGetTicketQuestionnaireTextAnswersResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * 購入情報確認ダッシュボードのrowデータファイルを取得する
         *
         * @generated from rpc spwn.dashboard.v1.LegacyPortalDashboardService.ExportPurchaseDashboardRowsFile
         */
        exportPurchaseDashboardRowsFile: {
            name: "ExportPurchaseDashboardRowsFile",
            I: legacy_portal_service_pb_1.LegacyPortalDashboardServiceExportPurchaseDashboardRowsFileRequest,
            O: legacy_portal_service_pb_1.LegacyPortalDashboardServiceExportPurchaseDashboardRowsFileResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
    }
};
//# sourceMappingURL=legacy_portal_service_connect.js.map